import { useState } from "react";
import { MenuItem, Stack, Box, Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import MenuPopover from "src/components/MenuPopover";
import { IconButtonAnimate } from "src/components/animate";
import useCurrencyCurrent from "src/contexts/CurrencyContext";

export default function CurrencyPopover() {
  const { allCurrency, currentCurrency, onChangeCurrency } =
    useCurrencyCurrent();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => setOpen(event.currentTarget);
  const handleClose = () => setOpen(null);

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={(theme) => ({
          px: 1,
          py: 0.45,
          borderRadius: 2.5,
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: open
            ? alpha(theme.palette.primary.main, 0.4)
            : alpha(theme.palette.grey[500], 0.18),
          bgcolor: alpha(theme.palette.common.white, 0.96),
          boxShadow: "0 8px 18px rgba(15, 23, 42, 0.04)",
          "&:hover": {
            bgcolor: theme.palette.common.white,
            borderColor: alpha(theme.palette.primary.main, 0.3),
          },
          ...(open && {
            boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.08)}`,
          }),
        })}
      >
        <Stack direction="row" spacing={0.9} alignItems="center">
          <Box
            component="span"
            aria-label={currentCurrency.label}
            sx={{ fontSize: 20, lineHeight: 1 }}
          >
            {currentCurrency.icon}
          </Box>

          <Chip
            size="small"
            label={currentCurrency.value}
            sx={{
              height: 34,
              minWidth: 66,
              fontWeight: 700,
              fontSize: 14,
              borderRadius: 999,
              bgcolor: "#F2F4F7",
              border: "1px solid #D9DEE7",
              color: "#2A3342",
              "& .MuiChip-label": {
                px: 1.25,
              },
            }}
          />
        </Stack>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          mt: 1.25,
          ml: 0.25,
          width: 160,
          p: 0.75,
          borderRadius: 3,
          border: "1px solid rgba(145, 158, 171, 0.14)",
          boxShadow: "0 18px 32px rgba(15, 23, 42, 0.08)",
          "& .MuiMenuItem-root": {
            px: 1,
            py: 0.65,
            minHeight: 46,
            borderRadius: 2,
          },
        }}
      >
        <Stack spacing={0.5}>
          {allCurrency.map((opt) => (
            <MenuItem
              key={opt.value}
              selected={opt.value === currentCurrency.value}
              onClick={() => {
                onChangeCurrency(opt.value);
                handleClose();
                window.location.reload();
              }}
              sx={{
                justifyContent: "space-between",
                bgcolor:
                  opt.value === currentCurrency.value
                    ? alpha("#919EAB", 0.12)
                    : "transparent",
                "&:hover": {
                  bgcolor: alpha("#919EAB", 0.08),
                },
              }}
            >
              <Box
                component="span"
                sx={{ fontSize: 20, mr: 1, lineHeight: 1 }}
              >
                {opt.icon}
              </Box>

              <Chip
                size="small"
                label={opt.value}
                sx={{
                  height: 30,
                  minWidth: 58,
                  fontWeight: 700,
                  fontSize: 13,
                  borderRadius: 999,
                  bgcolor: "#F2F4F7",
                  border: "1px solid #D9DEE7",
                  color: "#2A3342",
                  "& .MuiChip-label": {
                    px: 1,
                  },
                }}
              />
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
}
